import React from "react";
import Home from "./modules/Home";
import "./App.css";

function App() {
  return <Home />;
}

export default App;
